/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

export type FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags = typeof FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags[keyof typeof FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_4: 4,
  NUMBER_8: 8,
} as const;
